<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="winning-wrapper" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
      <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
      <div class="draw-winning-head" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">恭喜获得</div>
      <div :class="`code-wrapper ${prizeCodes.length === 1 ? 'num-one' : prizeCodes.length === 2 ? 'num-two' : 'num-more'}`">
        <div class="code" :style="`color: ${h5ConfigDetails[0]['fontColor']['prizeNameOrInputFontColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['inputBg'][0]};`" v-for="(code, idx) in prizeCodes" :key="idx">{{code}}</div>
      </div>
      <div class="prize-desc" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">请前往“中奖记录”查看</div>
      <div class="win-btn" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnTxtColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnBg'][0]};`" @click="_close">确定</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import ModalMask from '@/components/modal/ModalMask'

export default {
  name: 'MultiplePrizeWinning',
  components: {
    ModalMask
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath'])
  },
  data () {
    return {
      baseUrl,
      showing: false,
      prizeCodes: []
    }
  },
  methods: {
    _close () {
      this.showing = false
    },
    show (prizeCodes) {
      this.prizeCodes = prizeCodes.split(';')
      this.showing = true
    }
  }
}
</script>

<style scoped lang="less">
    @import '../../style/mixin';

  .winning-wrapper {
    width: 29.7rem;
    height: 25.3rem;
    background: rgb(255, 247, 238);
    .modal-common;
    /* .modal-anim; */
    text-align: center;
  }

  .winning-wrapper .draw-winning-head {
    font-size: 1.8rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #7E3E1B;
    line-height: 2.6rem;
    margin: 1.7rem 0 1.9rem 0;
  }

  .winning-wrapper .prize-desc {
    font-size: 1.07rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #B7704A;
    line-height: 1.4rem;
    margin-bottom: 0.87rem;
  }

  .winning-wrapper .win-btn {
    width: 24.1rem;
    height: 4rem;
    background: linear-gradient(90deg, #FF8250 0%, #FF4C59 100%);
    border-radius: 2rem 2rem 2rem 2rem;
    opacity: 1;
    font-size: 1.6rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 4rem;
    margin: auto;
  }

  .winning-wrapper .prize-img {
    width: 12.7rem;
    height: auto;
  }

  .code-wrapper {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1.6rem 1.1rem;
    height: 11.5rem;
  }

  .num-one {
    justify-content: center;
    align-items: center;
  }

  .num-two {
    justify-content: space-between;
    align-items: center;
  }

  .num-more {
    justify-content: space-between;
    align-items: baseline;
  }

  .num-one .code {
    width: 15.9rem !important;
  }

  .winning-wrapper .code {
    width: 12.9rem;
    height: 4.1rem;
    line-height: 4.1rem;
    background: #FDEDD6;
    border-radius: 0.6rem;
    opacity: 1;
    font-size: 13px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #7E3E1B;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 1rem;
  }
</style>
